module.exports = __webpack_public_path__ + "img/video.85bdb95a.svg";